import Cookies from 'js-cookie';

import { getMultiModalConfig } from './multiModalConfig.js';

const getCookieFunctions = (cookieName: string) => {
  const cookiePrefix = getMultiModalConfig()?.cookiePrefix ?? '';
  const finalCookieName = `${cookiePrefix}${cookieName}`;

  return {
    get: () => Cookies.get(finalCookieName) ?? null,
    set: (value: string, opt: { expires?: number | Date } = {}) => Cookies.set(finalCookieName, value, opt),
  };
};

export const cookies = {
  authToken: getCookieFunctions('authToken'),
  cookieConsent: getCookieFunctions('cookieConsent'),
};
